module.exports = __webpack_public_path__ + "img/liyou3.ede1fed0.png";